import type { LocaleStrings } from "../types.ts";

export const itLocale: LocaleStrings = {
  game: {
    defaultClanName: "Il tuo clan",
    clanSetupTitle: "Crea il tuo clan",
    clanSetupNameLabel: "Nome del clan",
    clanSetupNamePlaceholder: "Inserisci un nome",
    clanSetupConfirm: "Conferma",
    settleConfirm: "Continua",
    promptConfirmStart: "Inizi qui?",
    startTileConfirm: "Conferma",
    startTileCancel: "Annulla",
    clanSetupTotemLabel: "Totem",
    promptClanSetup: "Dai un nome al clan, scegli un totem e conferma per scegliere la casella iniziale.",
    statsHeaderFormat: "{clanName} · {turnLabel} {turn}",
    promptSelectStart: "Scegli dove deve iniziare il clan.",
    promptClanEstablished: "Clan fondato.",
    promptEndTurn: "Termina il turno quando sei pronto.",
    promptNewTurn: "Spostati su una casella adiacente o termina il turno.",
    promptVictory: "Il tuo clan prospera!",
    promptDefeat: "Il tuo clan è affamato.",
    tileContentsFormat: "{terrain} — {food} cibo/turno",
    tileContentsReducedFormat: "{terrain} — {effective}/{base} cibo/turno",
    tileTravelingFormat: "{terrain} — in viaggio, nessun raccolto questo turno",
    turnLabel: "Turno",
    dayNightLabels: {
      day: "Giorno",
      dusk: "Tramonto",
      night: "Notte",
      dawn: "Alba",
    },
    seasonLabels: {
      spring: "Primavera",
      summer: "Estate",
      autumn: "Autunno",
      winter: "Inverno",
    },
    temperatureFormat: "{value}°C",
    weatherLabels: {
      clear: "Sereno",
      cloudy: "Nuvoloso",
      overcast: "Coperto",
      rainy: "Pioggia",
      snowy: "Neve",
    },
    populationLabel: "Popolazione",
    foodLabel: "Cibo",
    waterLabel: "Acqua",
    ambientPredatorsLabel: "Predatori",
    ambientPredatorLevelLabels: {
      none: "Nessuno",
      low: "Basso",
      medium: "Medio",
      high: "Alto",
    },
    populationProgressFormat: "{current} / {max}",
    foodGrowthHintFormat: "→ crescita a {threshold}",
    statsCollapsedChipFormat: "Turno {turn} · {population} · {food} · {water} · {predators}",
    endTurnLabel: "Termina turno",
    terrainNames: {
      ["desert"]: "Deserto",
      ["mountain"]: "Montagna",
      ["swamp"]: "Palude",
      ["forest"]: "Foresta",
      ["plains"]: "Pianura",
      ["river"]: "Fiume",
    },
    totemNames: {
      carved: "Intagliato",
      antler: "Corna",
      spiral: "Spirale",
    },
    victoryTitle: "Vittoria!",
    victoryMessage: "Il tuo clan è cresciuto fino a 30 persone. Una vera civiltà ha inizio.",
    victoryRecapLineFormat: "{label}: {value}",
    victoryRecapTurns: "Turni alla vittoria",
    victoryRecapPopulation: "Popolazione",
    victoryRecapFood: "Cibo",
    victoryRecapStartTerrain: "Terreno iniziale",
    victoryRecapEndTerrain: "Terreno finale",
    victoryRecapExplored: "Mappa esplorata",
    victoryRecapExploredFormat: "{explored} / {total} caselle",
    defeatTitle: "Sconfitta",
    defeatMessage: "Gli ultimi del tuo popolo sono scomparsi.",
    startAgain: "Ricomincia",
    resetLabel: "Reset",
    exitGame: "Esci dal gioco",
    settingsTitle: "Impostazioni",
    settingsCloseAriaLabel: "Chiudi impostazioni",
    languageLabel: "Lingua",
    sfxVolumeLabel: "Effetti sonori — {level}",
    debugModeOff: "Modalità debug disattivata",
    debugModeOn: "Modalità debug attivata",
    fullscreenOff: "Schermo intero disattivato",
    fullscreenOn: "Schermo intero attivato",
    foodOverlayOff: "Mostra cibo sulla mappa",
    foodOverlayOn: "Nascondi cibo sulla mappa",
    waterOverlayOff: "Mostra acqua sulla mappa",
    waterOverlayOn: "Nascondi acqua sulla mappa",
    promptBannerHide: "Nascondi banner istruzioni",
    promptBannerShow: "Mostra banner istruzioni",
    stagingBadgeLabel: "Staging",
    hudSettingsTooltip: "Apri impostazioni",
    hudNotificationsTooltip: "Apri notifiche",
    notificationMarkDone: "Segna come completata",
    notificationOk: "OK",
    notificationCancel: "Annulla",
    closeAriaLabel: "Chiudi",
    leaveConfirmTitle: "Salvare e uscire?",
    leaveConfirmBody:
      "I tuoi progressi verranno salvati. Potrai continuare questa partita dalla schermata iniziale.",
    leaveConfirmSave: "Salva ed esci",
    leaveConfirmStay: "Resta in partita",
    leaveConfirmSaveFailed:
      "Impossibile salvare la partita. Libera spazio nel browser e riprova.",
    notificationEmpty: "Nessuna notifica al momento.",
    notificationPageOf: "{current} / {total}",
    notificationPageIndicatorOf: "({current} / {total})",
    notificationSwampTitle: "Zona paludosa",
    notificationSwampBody: "Il clan è entrato in una palude. Il terreno è molle e avanzare qui è più faticoso.",
    notificationFireTitle: "Fuoco scoperto",
    notificationFireBody:
      "Il clan ha trovato il fuoco su questa casella—una scoperta rara mentre esplori la mappa.",
    notificationFoodDepletionTitle: "Terra impoverita",
    notificationFoodDepletionBody:
      "Restare sulla stessa tessera ne riduce il cibo. Spostati e lascia che il terreno si riprenda nel tempo.",
    notificationTutorialTurnsTitle: "Il tuo primo turno",
    notificationTutorialTurnsBody:
      "Spostati su una casella adiacente, o termina il turno quando sei pronto.",
    notificationTutorialStatsTitle: "Le statistiche del clan",
    notificationTutorialStatsBody:
      "Il pannello in alto a sinistra mostra turno, ora del giorno, stagione, temperatura, meteo, popolazione, cibo, acqua e predatori sulla tua tessera. Premi E o tocca Termina turno quando sei pronto a raccogliere cibo e avanzare.",
    notificationTutorialWinGoalTitle: "Come vincere",
    notificationTutorialWinGoalBody:
      "Fai crescere il clan fino a 30 persone per vincere. Se la popolazione scende a zero, il clan è perduto.",
    notificationTutorialFoodEconomyTitle: "Cibo ogni turno",
    notificationTutorialFoodEconomyBody:
      "Quando termini il turno, la casella produce cibo. La popolazione mangia per prima—il resto si aggiunge o si sottrae dalle scorte.",
    notificationTutorialTileFoodTitle: "Leggere una casella",
    notificationTutorialTileFoodBody:
      "Ogni casella rivelata mostra terreno e cibo per turno. Esplora prima di stabilirti—terreni fertili come pianure e fiumi nutrono il clan più a lungo.",
    notificationTutorialGrowthTitle: "Crescita demografica",
    notificationTutorialGrowthBody:
      "Quando le scorte restano alte per diversi turni di fila, la popolazione cresce di uno.",
    notificationTutorialFamineTitle: "Fame",
    notificationTutorialFamineBody:
      "Se il clan resta affamato troppo a lungo, perdi una persona. Spostati su caselle fertili e accumula scorte.",
    notificationTutorialOneMoveTitle: "Muoversi ogni turno",
    notificationTutorialOneMoveBody:
      "Premi 1–6 o clicca una casella adiacente evidenziata per turno, o restare fermo. Restare troppo a lungo impoverisce il terreno.",
    notificationTutorialFoodOverlayTitle: "Cibo sulla mappa",
    notificationTutorialFoodOverlayBody:
      "Premi F o usa il pulsante del grano sull'HUD per mostrare il cibo sulle caselle rivelate senza aprirle una per una.",
    notificationTutorialLandRecoveryTitle: "Il terreno si riprende",
    notificationTutorialLandRecoveryBody:
      "Le caselle che lasci recuperano cibo nel tempo. Continua a muoverti per non esaurire un solo luogo.",
    notificationTutorialSettingsTitle: "Impostazioni",
    notificationTutorialSettingsBody:
      "Premi S o apri l'ingranaggio per cambiare lingua, regolare gli effetti sonori, attivare lo schermo intero, ricominciare o tornare alla schermata iniziale.",
    notificationTutorialRandomEventsTitle: "Eventi sulla mappa",
    notificationTutorialRandomEventsBody:
      "Possono comparire eventi inattesi mentre esplori. Premi N o apri la campanella per leggere cosa è successo.",
    languageLabels: {
      en: "Inglese",
      it: "Italiano",
      fr: "Francese",
      es: "Spagnolo",
      pt: "Portoghese",
      de: "Tedesco",
      zh: "Cinese",
      nl: "Olandese",
    },
  },
  site: {
    gameTitle: "Dawn of Clans",
    kofiButtonLabel: "Supporta su Ko-fi",
    discordLinkLabel: "Unisciti a Discord",
    landing: {
      primaryDescription:
        "Dawn of Clans è un gioco di grande strategia in cui guidi un clan preistorico attraverso sopravvivenza, scoperta ed evoluzione sociale.",
      secondaryDescription:
        "Partendo da un piccolo gruppo nomade, sbloccherai tecnologie con l'esperienza, ti adatterai a ambienti in cambiamento e plasmerai l'emergere delle prime civiltà.",
      earlyAccessLabel: "Accesso anticipato",
      earlyAccessNotice:
        "In fase di sviluppo iniziale. Il ciclo di sopravvivenza è giocabile oggi; sistemi strategici più profondi arriveranno.",
      learnMoreLabel: "Scopri di più",
      releaseNoticeText: "È appena stata rilasciata una nuova versione!",
      playLabel: "Gioca",
      continueLabel: "Continua",
      savedGameSummary: "Turno {turn}, Popolazione {population}",
      resumeModalTitle: "Partita salvata",
      newGameLabel: "Nuova partita",
      loadingLabel: "Caricamento...",
      changelogLink: "Novità",
      careerTeaserFormat:
        "{wins} vittorie · record: {fastest} turni · più esplorato: {explored}",
      careerViewChronicleLabel: "Vedi cronologia vittorie",
      chronicleModalTitle: "Cronologia vittorie",
      chronicleModalCloseLabel: "Chiudi",
      chronicleEntryFormat: "{clanName} · {turns} turni · {date}",
      chronicleClearWinHistoryLabel: "Cancella cronologia vittorie",
      chronicleClearWinHistoryBody:
        "Rimuove tutte le vittorie salvate su questo dispositivo. La partita in corso non viene modificata.",
      chronicleClearWinHistoryConfirm: "Sì, cancella cronologia",
      chronicleClearWinHistoryCancel: "Annulla",
      settingsGearAriaLabel: "Impostazioni",
      settingsCloseAriaLabel: "Chiudi impostazioni",
    },
    about: {
      pageTitle: "Informazioni su Dawn of Clans",
      backLinkLabel: "← Torna a Dawn of Clans",
      sections: [
        {
          heading: "Panoramica",
          body: "Dawn of Clans è un gioco di grande strategia in cui guidi un clan preistorico attraverso sopravvivenza, scoperta ed evoluzione sociale. Partendo da un piccolo gruppo nomade, sbloccherai tecnologie con l'esperienza, ti adatterai a ambienti in cambiamento e plasmerai l'emergere delle prime civiltà.",
        },
        {
          heading: "Il tuo clan",
          body: "All'inizio di una nuova partita, dai un nome al clan e scegli dove stabilirti sulla mappa esagonale. Dopo aver fondato il primo insediamento, controlla turno, popolazione e cibo nel pannello statistiche. Termina ogni turno per nutrire il clan e decidi se spostarti su una casella adiacente prima del turno successivo.",
        },
        {
          heading: "Progressione",
          body: "Ogni terreno produce una quantità diversa di cibo a turno. Quando le scorte di cibo restano alte per diversi turni consecutivi, la popolazione cresce; se il clan resta affamato troppo a lungo, si perdono persone. Accumula riserve su terreni fertili come fiumi e pianure, poi fai crescere il clan fino a trenta persone per vincere. Se la popolazione scende a zero, il clan scompare.",
        },
        {
          heading: "Il mondo",
          body: "Esplora una mappa esagonale dove le caselle partono nascoste. Clicca per rivelare deserto, montagna, palude, foresta, pianura e fiume. Scegli dove stabilire il primo insediamento, poi spostati di una casella adiacente per turno. Le terre fertili nutrono più bocche; quelle ostili consumano rapidamente le scorte.",
        },
        {
          heading: "Stato",
          body: "Dawn of Clans è in fase di sviluppo iniziale. Esplorazione, insediamento, cibo e popolazione a turni e vittoria o sconfitta sono giocabili oggi. Sistemi strategici più profondi sono ancora in costruzione.",
        },
      ],
      communitySection: {
        heading: "Community",
        body: "Chatta con altri giocatori, condividi feedback e segui gli aggiornamenti di sviluppo sul nostro server Discord.",
      },
      supportSection: {
        heading: "Supporta il progetto",
        body: "Ti piace Dawn of Clans? Le donazioni opzionali su Ko-fi aiutano a finanziare lo sviluppo continuo.",
      },
    },
    changelog: {
      pageTitle: "Novità",
      backLinkLabel: "← Torna a Dawn of Clans",
      loadError: "Impossibile caricare le novità.",
      emptyState: "Nessuna versione pubblicata.",
    },
  },
};
